import React, {useEffect, useState} from 'react';
import {IonButton, IonItem, IonLabel, IonList, IonReorder, IonReorderGroup} from '@ionic/react';
import createAxiosInstance from "../services/AxiosInstance";
import {useToast} from "../Utils/useToasts";
import {DertigenPlayer} from "../model/DertigenPlayer";
import {User} from "../model/User";

interface ReorderPlayerProps {
    lobbyId: any;
}

export const ReorderPlayers: React.FC<ReorderPlayerProps> = ({lobbyId}) => {
    const [players, setPlayers] = useState<User[]>([]);
    const axios = createAxiosInstance();
    const showToast = useToast();

    const doReorder = (event: CustomEvent) => {
        const {detail} = event;
        if (detail.from !== detail.to) {
            const updatedPlayers = [...players];
            const [reorderedItem] = updatedPlayers.splice(detail.from, 1);
            updatedPlayers.splice(detail.to, 0, reorderedItem);
            setPlayers(updatedPlayers);
            detail.complete();
        } else {
            detail.complete();
        }
    };

    const saveOrder = async () => {
        const playerIds = players.map(player => player.id);

        try {
            const response = await axios.patch(`/lobbies/${lobbyId}/lobby-state/players-order`, playerIds);
            showToast('De nieuwe volgorde is opgeslagen.', 'success');
            console.log('New order saved:', response.data);
        } catch (error) {
            showToast('Er is een fout opgetreden bij het opslaan van de nieuwe volgorde.', 'danger');
            console.error('Error saving new order:', error);
        }
    };


    useEffect(() => {

        const fetchPlayers = async () => {
            try {
                await axios.get(`/lobbies/${lobbyId}/lobby-state/players-order`)
                    .then(res => {
                        setPlayers(res.data);
                    })
                    .catch(err => {
                        console.error('Error fetching players:', err);
                        showToast('Er is iets mis gegaan', "danger")
                    });

            } catch (err) {
                console.error('Error fetching players:', err);
            }
        }

        fetchPlayers();
    }, []);

    return (
        <>
            <IonList>
                <IonReorderGroup disabled={false} onIonItemReorder={doReorder}>
                    {players.map((player: User) => (
                        <IonItem key={player?.id}>
                            <IonLabel>{player?.name}</IonLabel>
                            <IonReorder slot="end"/>
                        </IonItem>
                    ))}
                </IonReorderGroup>
            </IonList>
            <IonButton onClick={saveOrder} expand="block">Volgorde opslaan</IonButton>
        </>
    );
};

export default ReorderPlayers;
